/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Analytics_Totaltokenusage2Inputs */

const zh_analytics_totaltokenusage2 = /** @type {(inputs: Analytics_Totaltokenusage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`总 Token 用量`)
};

const en_analytics_totaltokenusage2 = /** @type {(inputs: Analytics_Totaltokenusage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total Token Usage`)
};

const es_analytics_totaltokenusage2 = /** @type {(inputs: Analytics_Totaltokenusage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uso total de tokens`)
};

/**
* | output |
* | --- |
* | "Total Token Usage" |
*
* @param {Analytics_Totaltokenusage2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const analytics_totaltokenusage2 = /** @type {((inputs?: Analytics_Totaltokenusage2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Analytics_Totaltokenusage2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_analytics_totaltokenusage2(inputs)
	if (locale === "en") return en_analytics_totaltokenusage2(inputs)
	return es_analytics_totaltokenusage2(inputs)
});
export { analytics_totaltokenusage2 as "analytics_totalTokenUsage" }